import React from 'react';

import { ReactComponent as Chevron } from 'assets/icons/chevron.svg';

function SectionLink(props) {
	const { onClick,align=()=>"ltr", children, ...otherProps } = props;
	function getChevronStyle()
	{
		if(align()==="rtl")
		return "rotate-90 c-secondary-500"
		return "rotate-270 c-secondary-500"		
	}
	return (
		<div className='nmx-4 px-4'>
			<div {...otherProps}  className='h-13 flex flex-middle flex-between flex-1' onClick={onClick}>
				<p className='fs-4 c-neutral-700'>{children}</p>
				{/* <Chevron className='rotate-270 c-secondary-500' height={12} width={12} /> */}
				<Chevron className={getChevronStyle()} height={12} width={12} />
			</div>
		</div>
	);
}

export default SectionLink;
